import actionTypes from './actionTypes';

const INITIAL_STATE = {
  insertNewReservationTimingLoading: false,
  insertNewReservationTimingReject: false,
  insertNewReservationTimingFailed: false,
  insertNewReservationTimingMessage: null,
  inserNewReservationTimingFailedMessageList: [],

  updateReservationTimingLoading: false,
  updateReservationTimingReject: false,
  updateReservationTimingFailed: false,
  updateReservationTimingMessage: null,
  updateReservationTimingMessageList: [],

  getAllReservationTimingLoading: false,
  getAllReservationTimingReject: false,
  getAllReservationTimingFailed: false,
  getAllReservationTimingMessage: null,
  reservationTimingList: [],
  totalRecords: null,

  getReservationTimingDetailsLoading: false,
  getReservationTimingDetailsReject: false,
  getReservationTimingDetailsFailed: false,
  getReservationTimingDetailsMessage: null,
  reservationTimingDetails: [],

  deleteReservationTimingLoading: false,
  deleteReservationTimingReject: false,
  deleteReservationTimingFailed: false,
  deleteReservationTimingMessage: null,

};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.INSERT_NEW_RESERVATION_TIMING_LOADING: {
      return {
        ...state,
        insertNewReservationTimingLoading: true,
        insertNewReservationTimingReject: false,
        insertNewReservationTimingFailed: false,
        insertNewReservationTimingMessage: null,
        inserNewReservationTimingFailedMessageList: [],
      };
    }
    case actionTypes.INSERT_NEW_RESERVATION_TIMING_REJECT: {
      return {
        ...state,
        insertNewReservationTimingLoading: false,
        insertNewReservationTimingReject: true,
        insertNewReservationTimingFailed: false,
        insertNewReservationTimingMessage: null,
        inserNewReservationTimingFailedMessageList: [],
      };
    }
    case actionTypes.INSERT_NEW_RESERVATION_TIMING_FAILED: {
      const { message, errors } = action.payload;
      return {
        ...state,
        insertNewReservationTimingLoading: false,
        insertNewReservationTimingReject: false,
        insertNewReservationTimingFailed: true,
        insertNewReservationTimingMessage: message,
        inserNewReservationTimingFailedMessageList: errors,
      };
    }
    case actionTypes.INSERT_NEW_RESERVATION_TIMING_SUCCESS: {
      return {
        ...state,
        insertNewReservationTimingLoading: false,
        insertNewReservationTimingReject: false,
        insertNewReservationTimingFailed: false,
        insertNewReservationTimingMessage: null,
        inserNewReservationTimingFailedMessageList: [],
      };
    }


    case actionTypes.UPDATE_RESERVATION_TIMING_LOADING: {
      return {
        ...state,
        updateReservationTimingLoading: true,
        updateReservationTimingReject: false,
        updateReservationTimingFailed: false,
        updateReservationTimingMessage: null,
        updateReservationTimingMessageList: [],
      };
    }
    case actionTypes.UPDATE_RESERVATION_TIMING_REJECT: {
      return {
        ...state,
        updateReservationTimingLoading: false,
        updateReservationTimingReject: true,
        updateReservationTimingFailed: false,
        updateReservationTimingMessage: null,
        updateReservationTimingMessageList: [],
      };
    }
    case actionTypes.UPDATE_RESERVATION_TIMING_FAILED: {
      const { message, errors } = action.payload;
      return {
        ...state,
        updateReservationTimingLoading: false,
        updateReservationTimingReject: false,
        updateReservationTimingFailed: true,
        updateReservationTimingMessage: message,
        updateReservationTimingMessageList: errors,
      };
    }
    case actionTypes.UPDATE_RESERVATION_TIMING_SUCCESS: {
      return {
        ...state,
        updateReservationTimingLoading: false,
        updateReservationTimingReject: false,
        updateReservationTimingFailed: false,
        updateReservationTimingMessage: null,
        updateReservationTimingMessageList: [],
      };
    }


    case actionTypes.GET_ALL_RESERVATION_TIMING_LIST_LOADING: {
      return {
        ...state,
        getAllReservationTimingLoading: true,
        getAllReservationTimingReject: false,
        getAllReservationTimingFailed: false,
        getAllReservationTimingMessage: null,
        reservationTimingList: [],
        totalRecords: null,
      };
    }
    case actionTypes.GET_ALL_RESERVATION_TIMING_LIST_REJECT: {
      return {
        ...state,
        getAllReservationTimingLoading: false,
        getAllReservationTimingReject: true,
        getAllReservationTimingFailed: false,
        getAllReservationTimingMessage: null,
        reservationTimingList: [],
        totalRecords: null,
      };
    }
    case actionTypes.GET_ALL_RESERVATION_TIMING_LIST_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getAllReservationTimingLoading: false,
        getAllReservationTimingReject: false,
        getAllReservationTimingFailed: true,
        getAllReservationTimingMessage: message,
        reservationTimingList: [],
        totalRecords: null,
      };
    }
    case actionTypes.GET_ALL_RESERVATION_TIMING_LIST_SUCCESS: {
      return {
        ...state,
        getAllReservationTimingLoading: false,
        getAllReservationTimingReject: false,
        getAllReservationTimingFailed: false,
        getAllReservationTimingMessage: null,
        reservationTimingList: [...action.payload.cafeSchedules],
        totalRecords: action.payload.totalRecords,
        inserNewReservationTimingFailedMessageList: [],
        insertNewReservationTimingMessage: null,
        updateReservationTimingMessageList: [],
        updateReservationTimingMessage: null,
        insertNewReservationTimingFailed: false,
        updateReservationTimingFailed: false,
      };
    }


    case actionTypes.GET_RESERVATION_TIMING_DETAILS_LOADING: {
      return {
        ...state,
        getReservationTimingDetailsLoading: true,
        getReservationTimingDetailsReject: false,
        getReservationTimingDetailsFailed: false,
        getReservationTimingDetailsMessage: null,
        reservationTimingDetails: [],
        inserNewReservationTimingFailedMessageList: [],
        insertNewReservationTimingMessage: null,
        updateReservationTimingMessageList: [],
        updateReservationTimingMessage: null,
      };
    }
    case actionTypes.GET_RESERVATION_TIMING_DETAILS_REJECT: {
      return {
        ...state,
        getReservationTimingDetailsLoading: false,
        getReservationTimingDetailsReject: true,
        getReservationTimingDetailsFailed: false,
        getReservationTimingDetailsMessage: null,
        reservationTimingDetails: [],
      };
    }
    case actionTypes.GET_RESERVATION_TIMING_DETAILS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getReservationTimingDetailsLoading: false,
        getReservationTimingDetailsReject: false,
        getReservationTimingDetailsFailed: true,
        getReservationTimingDetailsMessage: message,
      };
    }
    case actionTypes.GET_RESERVATION_TIMING_DETAILS_SUCCESS: {
      return {
        ...state,
        reservationTimingDetails: action.payload,
        inserNewReservationTimingFailedMessageList: [],
        insertNewReservationTimingMessage: null,
        updateReservationTimingMessageList: [],
        updateReservationTimingMessage: null,
        insertNewReservationTimingFailed: false,
        updateReservationTimingFailed: false,
      };
    }


    case actionTypes.DELETE_RESERVATION_TIMING_LOADING: {
      return {
        ...state,
        deleteReservationTimingLoading: true,
        deleteReservationTimingReject: false,
        deleteReservationTimingFailed: false,
        deleteReservationTimingMessage: null,
      };
    }
    case actionTypes.DELETE_RESERVATION_TIMING_REJECT: {
      return {
        ...state,
        deleteReservationTimingLoading: false,
        deleteReservationTimingReject: true,
        deleteReservationTimingFailed: false,
        deleteReservationTimingMessage: null,
      };
    }
    case actionTypes.DELETE_RESERVATION_TIMING_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        deleteReservationTimingLoading: false,
        deleteReservationTimingReject: false,
        deleteReservationTimingFailed: true,
        deleteReservationTimingMessage: message,
      };
    }
    case actionTypes.DELETE_RESERVATION_TIMING_SUCCESS: {
      return {
        ...state,
        deleteReservationTimingLoading: false,
        deleteReservationTimingReject: false,
        deleteReservationTimingFailed: false,
        deleteReservationTimingMessage: null,
        reservationTimingList: action.payload,
      };
    }

    default:
      return state;
  }
};
